import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';
import objectFitImages from 'object-fit-images';
// import appStoreBadge from '../../component/img/app_store_badge.png';
// import googlePlayBadge from '../../component/img/google-play-badge.png';

import CopyProvider from '../copy_provider';
import './email_confirmation.css';

export default class EmailConfirmation extends Component {
  render() {
    return (
      <div>
        <div className="email_confirmation_body">
          <div className="email_confirmation_body_content">
            <CopyProvider copyKey={ `email_confirmation_title_${this.props.success_type}` } />
            <CopyProvider copyKey={ `email_confirmation_subtitle_${this.props.success_type}` } />

            <div className="email_confirmation_evgo_app_info">
              <CopyProvider copyKey={ `email_confirmation_content_list_${this.props.success_type}` } />
              {/* Download the app
              <a href="https://itunes.apple.com/us/app/evgo/id1281660968?mt=8" target="_blank" rel="noopener noreferrer"><img src={ appStoreBadge } alt="" /></a>
              <a href="https://play.google.com/store/apps/details?id=com.driivz.mobile.android.evgo.driver" target="_blank" rel="noopener noreferrer"><img src={ googlePlayBadge } alt="" /></a> */}
            </div>
          </div>
        </div>

        <div key="code_entry_footer" className="code_entry_footer">
          <div className="code_entry_footer_content_left">
            <div>
              <Icon className="blue" name="question circle" />
              <b>Questions?</b>
            </div>

            <div>Call <b>877-494-3833</b> or email <b><a href="mailto:support@evgo.com" target="_blank" rel="noopener noreferrer">support@evgo.com</a></b></div>
          </div>

          <div className="code_entry_footer_content_right">
            <b>&copy; 2019 EVgo Services LLC</b>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    objectFitImages();
  }

  componentDidUpdate() {
    objectFitImages();
  }
}



// WEBPACK FOOTER //
// ./src/content/email_confirmation/email_confirmation.js